import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "next-i18next";
import {
  FieldErrorsImpl,
  FieldValues,
  SubmitHandler,
  useForm,
} from "react-hook-form";

import { Form, Illustration, InputText, Text } from "@/components/elements";
import { NewsletterData } from "@/types/types";
import setSchema, { email } from "@/utils/validation";

import styles from "./styles.module.css";

type PromptProps = {
  onSubmit: SubmitHandler<NewsletterData>;
  dismiss: () => void;
  isLoading: boolean;
};

export const SubscribePrompt = ({
  onSubmit,
  dismiss,
  isLoading,
}: PromptProps) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<NewsletterData>({
    mode: "onSubmit",
    defaultValues: {},
    criteriaMode: "all",
    shouldFocusError: true,
    resolver: yupResolver(setSchema({ ...email(t("error_email_only")) })),
  });

  return (
    <>
      <Illustration type="confused" className={styles.illustration} />
      <Text as="h2" size="l" className={styles.title}>
        {t("newsletter_banner.prompt.title")}
      </Text>
      <Text className={styles.content}>
        {t("newsletter_banner.prompt.content")}
      </Text>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        isLoading={isLoading}
        primaryButtonText={t("newsletter_banner.prompt.cta")}
        secondaryButtonText={t("newsletter_banner.prompt.close")}
        secondaryButtonAction={dismiss}
        className={styles.form}
      >
        <InputText
          key="email-field"
          id="email-field"
          name="email"
          label="Email address"
          type="email"
          version="box"
          theme="dark"
          register={register}
          errors={errors as FieldErrorsImpl<FieldValues>}
          inputClassName={styles.input}
          hideLabel
          placeholder={t("email_address")}
        />
      </Form>
    </>
  );
};
